import { TrustpilotMicroCombo, TrustpilotMicroStar } from '@hg/stylizator/components'
import { useSizes } from '@hg/stylizator/hooks'
import { media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { IAttributes } from 'app/components/CustomBlocks/component/TrustpilotWidget/TrustpilotWidget'

const TrustPilot: React.FC<IAttributes> = ({ invertedColour }) => {
  const { isDesktop } = useSizes()

  return (
    <WidgetWrapper>
      <IframeWrapper>
        {isDesktop ? (
          <TrustpilotMicroCombo theme={invertedColour ? 'dark' : 'light'} width="100%" />
        ) : (
          <TrustpilotMicroStar theme={invertedColour ? 'dark' : 'light'} width="100%" />
        )}
      </IframeWrapper>
    </WidgetWrapper>
  )
}

const WidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`

const IframeWrapper = styled.div`
  width: 100%;

  @media ${media.mobile} {
    margin-bottom: 8px;
  }
`

export default React.memo(TrustPilot)
